import React, { useState, useEffect } from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  TextInput,
  ScrollView,
} from "react-native";
import Dawer from "../../component/drawer";
import Admin from "../../component/admin";
import RNPickerSelect from "react-native-picker-select";
import { apiservice } from "../../service/service";
import { useRecoilValue } from "recoil";
import { tokenState } from "../../reducer/reducer/reducer/Atom";
import { useIsFocused } from "@react-navigation/native";
import { getevent } from "../../action/actionGet";
const { width, height } = Dimensions.get("window");

export default function createAdmin({ navigation }) {
  const token = useRecoilValue(tokenState);
  const packages = "";
  const bibz = ""
  const focus = useIsFocused();
  const full = {
    ShippingAddress: "",
    subDistrict: "",
    district: "",
    province: "",
    postcode: "",
  }

  const placeholder = {
    label: "Role",
    value: null,
    color: "#777777",
  };

  const items = [
    { label: "Admin", value: "ADMIN" },
    { label: "Event", value: "EVENT" },
  ]

  const [body, setBody] = useState({
    Type: "EMAIL",
    role: "",
    username: "",
    image_Profile: null,
    email: null,
    full_address: {},
    name: "",
    tel: "",
    password: "",
    event_id: "",
  });
  const [events, setEvents] = useState([]);

  async function allEvent() {
    const results = await getevent(token);
    if (results.status == 200) {
      const eventList = results?.data?.data || [];
      setEvents(
        eventList.map((item) => {
          return { label: item.titel, value: (item?.id).toString() };
        })
      );
    }
  }

  useEffect(() => {
    allEvent();
  }, [token, focus]);

  async function handleSubmit() {
    const response = await apiservice({
      path: "/authen/register",
      method: "post",
      body: {
        ...body,
        full_address: full,
        link: body.role == "VIP",
        email: body?.email || body?.username + "@example.com",
      },
      token: token?.accessToken,
    });

    if (response.status == 200) {
      navigation.goBack();
    }
  }

  return (
    <View style={styles.container}>
      <Dawer navigation={navigation} />
      <ScrollView>
        <View style={styles.back}>
          <Admin />
          <View style={styles.viewfree}>
            <Text style={styles.textfree}>
              Admin{" "}
              <Text style={styles.textfree}>
                / <Text style={styles.textfree}>Add Account</Text>
              </Text>
            </Text>
            <TouchableOpacity
              onPress={handleSubmit}
              style={styles.touchadd}
            >
              <Text style={styles.textadd}>CREATE</Text>
            </TouchableOpacity>
          </View>

          <View style={[styles.viewfree, { marginTop: 30 }]}>
            <View style={styles.viewfor}>
              <Text style={styles.textname1}>USER</Text>
              <TextInput
                placeholder="กรอกuser"
                style={styles.inputuser}
                onChangeText={(text) => {
                  setBody({ ...body, username: text });
                }}
              />

              <Text style={styles.textname1}>PASSWORD</Text>
              <TextInput
                placeholder="กรอกรหัสผ่าน"
                style={styles.inputuser}
                onChangeText={(text) => {
                  setBody({ ...body, password: text });
                }}
              />

              <Text style={styles.textname1}>Event</Text>
              <RNPickerSelect
                placeholder={"Select Event"}
                onValueChange={(text) => {
                  setBody((val) => ({ ...val, event_id: text }));
                }}
                style={{
                  inputWeb: {
                    width: width * 0.23,
                    height: 30,
                    borderWidth: 1,
                    borderColor: "#ccc",
                    paddingLeft: 10,
                    borderRadius: 5,
                    color: "#777777",
                    fontFamily: "Prompt-Regular",
                    alignSelf: "center",
                  },
                }}
                items={events}
              />
            </View>

            <View>
              <Text style={styles.textname}>Role</Text>
              <RNPickerSelect
                placeholder={placeholder}
                onValueChange={(text) => {
                  setBody((val) => ({ ...val, role: text }));
                }}
                style={{
                  inputWeb: {
                    width: width * 0.23,
                    height: 30,
                    borderWidth: 1,
                    borderColor: "#ccc",
                    paddingLeft: 10,
                    borderRadius: 5,
                    color: "#777777",
                    fontFamily: "Prompt-Regular",
                    alignSelf: "center",
                  },
                }}
                items={items}
              />
            </View>

          </View>
        </View>
      </ScrollView>
    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    width: width,
    height: height,
    backgroundColor: "#F3F3F3",
    flexDirection: "row",
  },
  back: {
    width: width * 0.85,
    height: height,
    paddingHorizontal: width * 0.01,
  },
  viewfree: {
    justifyContent: "space-between",
    width: width * 0.82,
    flexDirection: "row",
  },
  textfree: {
    fontFamily: "Prompt-Regular",
    fontSize: 25,
    color: "#000",
    fontWeight: "bold",
    alignSelf: "center",
  },
  textfree2: {
    fontFamily: "Prompt-Regular",
    fontSize: 20,
    color: "#000",
    marginTop: 10,
  },
  touchadd: {
    width: 150,
    height: 40,
    justifyContent: "center",
    backgroundColor: "#fff",
    alignSelf: "center",
  },
  textadd: {
    fontFamily: "Prompt-Regular",
    fontSize: 24,
    color: "#172B4D",
    alignSelf: "center",
  },
  textfree1: {
    fontFamily: "Prompt-Regular",
    fontSize: 20,
    color: "#000",
    alignSelf: "center",
  },
  textname: {
    fontSize: 18,
    color: "#000000",
    fontFamily: "Prompt-Regular",
  },
  textname1: {
    fontSize: 16,
    color: "#000000",
    fontFamily: "Prompt-Regular",
  },
  inputuser: {
    width: width * 0.23,
    height: 30,
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
    color: "#777777",
    fontFamily: "Prompt-Regular",
    marginBottom: 10,
  },
  inputadd: {
    width: width * 0.16,
    height: 30,
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
    color: "#777777",
    fontFamily: "Prompt-Regular",
    marginBottom: 10,
  },
  inputadd1: {
    width: width * 0.16,
    height: 100,
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
    color: "#777777",
    fontFamily: "Prompt-Regular",
    marginBottom: 10,
  },
  viewfor: {
    width: width * 0.55,
    backgroundColor: "#FFF",
    padding: 10,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    borderRadius: 10,
  },
  inputimni: {
    width: width * 0.1,
    height: 30,
    fontFamily: "Prompt-Regular",
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
  },
  view: {
    width: width * 0.82,
    borderWidth: 0.05,
    borderColor: "#00000010",
    backgroundColor: "#fff",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    marginTop: 10,
    paddingHorizontal: 10,
    paddingVertical: 20,
  },
  viewmainfor: {
    flexDirection: "row",
    width: width * 0.3,
    justifyContent: "space-between",
  },
});
